import React, { useRef, useState, useEffect, useMemo } from 'react';
import { Text, Button, Icon, Content } from 'native-base';
import { Platform, View, Dimensions } from 'react-native';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import WebView from 'react-native-webview';
import downloader from './downloader';

//import { usePdf } from 'react-pdf-js';
import { usePdf } from '@mikecousins/react-pdf';

export default function aPdf(props) {
	const { width, scale, height } = Dimensions.get('window');
	const [page, setPage] = useState(1);

	const [pdfScale, setScale] = useState(1);

	const canvasRef = useRef();

	var { htmlContent, pdfContent } = props;

	//const onDocumentLoadFail = useMemo(() => console.log('feil'));

	const renderPagination = (page, pages) => {
		if (!pages) return null;

		return (
			<View style={{ position: 'absolute', bottom: 50, flexDirection: 'row', justifyContent: 'center', flex: 1, backgroundColor: '#BBB', opacity: 0.8, alignSelf: 'center', alignItems: 'center' }}>
				{props.showDownload && (
					<Button light onPress={() => downloader(pdfContent.replace('data:application/pdf;base64,', ''), 'Preview')}>
						<MaterialIcons name="file-download" style={{ fontSize: 24, margin: 10, color: '#444' }} />
					</Button>
				)}
				<Button transparent dark disabled={page == 1} onPress={() => setPage(page - 1)}>
					<Icon name="arrow-back" style={{ color: page == 1 ? '#CCC' : '#444' }}></Icon>
				</Button>
				<Text style={{ marginHorizontal: 8 }}>
					Page {page} of {pages}
				</Text>
				<Button dark transparent disabled={page == pages} onPress={() => setPage(page + 1)}>
					<Icon name="arrow-forward" style={{ color: page == pages ? '#CCC' : '#444' }}></Icon>
				</Button>

				<Button light disabled={pdfScale < 0.2} onPress={() => setScale(pdfScale / 2)}>
					<MaterialIcons name="zoom-out" style={{ fontSize: 24, margin: 10, color: pdfScale < 0.2 ? '#CCC' : '#444' }} />
				</Button>
				<Button light onPress={() => setScale(pdfScale + 0.5)}>
					<MaterialIcons name="zoom-in" style={{ fontSize: 24, margin: 10, color: '#444' }} />
				</Button>
			</View>
		);
	};

	if (!pdfContent) {
		const zoom = width ? (width / (800 * scale)).toString() : '1';
		htmlContent = htmlContent && htmlContent.replace('<html>', '<html style="zoom:' + zoom + '">');
		return window.navigator.userAgent.indexOf('Edge') > -1 ? (
			<div style={{ border: 1, borderColor: '#444', borderStyle: 'dotted', margin: 10, height: '100%', overflowY: 'scroll' }} dangerouslySetInnerHTML={{ __html: htmlContent }} />
		) : (
			<iframe style={{ border: 1, borderColor: '#444', borderStyle: 'dotted', margin: 10, height: '100%', overflowY: 'scroll' }} srcDoc={htmlContent} />
		);
	}

	const { pdfDocument, pdfPage } = usePdf({
		file: pdfContent,
		scale: pdfScale,
		page,
		height: props.height,
		canvasRef,
		onDocumentLoadFail: f => console.log(f)
	});

	//console.log(pdfScale);

	return (
		<View
			style={{ height: props.height, flex: 1 }}
			onLayout={event => {
				var { x, y, width, height } = event.nativeEvent.layout;
				console.log(width, height);
				if (width / height > 210 / 297) {
					//wider than A4
					//makeHeight = (width / 210) * 297;
					setScale(height / ((width / 210) * 297));
				} else {
					//narrower than A4
					//makeWidth = (height / 297) * 210;
					setScale(width / ((height / 297) * 210));
				}
			}}>
			<View style={{ flex: 1, overflow: 'scroll', alignItems: 'center', justifyContent: 'center', backgroundColor: '#DDD' }}>
				<canvas style={{ height: '100%', width: '100%' }} ref={canvasRef} />
			</View>
			{renderPagination(page, pdfDocument && pdfDocument.numPages)}
		</View>
	);
}
